import React from 'react';
import './OfflineInstructions.css';

import { FaCircleNotch } from 'react-icons/fa';



const OfflineInstructions = () => {

    return (

        <>
            <p>Please follow the instructions below to make an offline donation to <strong>Blazeguard Fire Department:</strong></p>

            <ol>
                <li>
                    <strong>Bank Transfer:</strong>
                    <ul>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>Bank Name:</strong> Firefighters Credit Union</li>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>Account Name:</strong> Blazeguard Fire Department Relief Fund</li>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>Account Number:</strong> 9876543210</li>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>Branch:</strong> Central City Branch</li>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>IFSC Code:</strong> FCU0012345</li>
                    </ul>
                </li>
                <li>
                    <strong>Cheque:</strong>
                    <ul>
                        <li>Make payable to: <strong>Blazeguard Fire Department Relief Fund</strong></li>
                        <li>Mail to: <strong>456 Rescue Drive, Central City, ZIP 10001</strong></li>
                    </ul>
                </li>
                <li>
                    <strong>Cash:</strong>
                    <ul>
                        <li>Visit: <strong>456 Rescue Drive, Central City, ZIP 10001</strong></li>
                        <li>Hours: <strong>Monday-Friday, 8:00 AM - 6:00 PM</strong></li>
                    </ul>
                </li>
            </ol>
        </>

    );

}

export default OfflineInstructions;